import { useEffect, useCallback } from 'react';
import { useGridStore } from '../store/gridStore';
import type { PendingSlot } from '../store/gridStore';

export function useGrid(userId: number) {
	const {
		rows,
		slots,
		conflicts,
		loading,
		error,
		actionError,
		undoStack,
		redoStack,
		load,
		commitGesture,
		undo,
		redo,
		clearActionError,
	} = useGridStore();

	useEffect(() => {
		load();
	}, []);

	const isFilled = useCallback(
		(uid: number, tid: number, date: string, hour: number) => slots.has(`${uid}:${tid}:${date}:${hour}`),
		[slots],
	);

	const isConflict = useCallback(
		(uid: number, tid: number, date: string, hour: number) => conflicts.has(`${uid}:${tid}:${date}:${hour}`),
		[conflicts],
	);

	const commit = useCallback((pending: PendingSlot[]) => commitGesture(pending), [commitGesture]);

	return {
		rows,
		loading,
		isLoaded: !loading,
		error,
		actionError,
		clearActionError,
		canUndo: undoStack.length > 0,
		canRedo: redoStack.length > 0,
		isFilled,
		isConflict,
		commit,
		undo,
		redo,
		reload: load,
	};
}
